<template>
  <div class="history">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>检测业务台账</span>
      </div>
      <!-- 筛选 -->
      <el-row>
        <!-- 搜索条件 -->
        <el-col :span="4">
          <el-input
            v-model="deviceName"
            placeholder="请输入设备名称"
          ></el-input>
        </el-col>

        <!-- 搜索 -->
        <el-col :span="1">
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="search"
          ></el-button>
        </el-col>
        <el-col :span="18">&nbsp;</el-col>
        <!-- 下载 -->
        <el-col :span="1">
          <el-button
            v-if="tableData.length != 0"
            icon="el-icon-download"
            type="info"
            plain
            :loading="downloadLoading"
            @click="download"
          ></el-button>
        </el-col>
      </el-row>
      <!-- 筛选 -->
      <el-table :data="tableData" border stripe style="width: 100%" ref="table">
        <el-table-column type="index" align="center" :index="1">
          <template #header>
            <i
              class="el-icon-setting"
              style="font-size: 22px; cursor: pointer"
              @click="dialogVisible = true"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <!-- @click="handleClick(scope.row)" -->
            <el-button type="text">
              <a target="_blank" :href="getImgUrl(scope.row.reportFileurl)"
                >查看报表</a
              >
              <!-- <a href="https://www.baidu.com">查看报表</a> -->
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, i) in columnList"
          :key="i"
          :prop="item.prop"
          :label="item.label"
          sortable
        >
        </el-table-column>
      </el-table>
      <!-- dialog -->
      <el-dialog title="字段配置" :visible.sync="dialogVisible" width="30%">
        <div>
          <div>选择显示字段</div>
          <div v-for="(item, i) in column" :key="i">
            <el-checkbox v-model="item.show">{{ item.label }}</el-checkbox>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
          <el-button type="primary" @click="tochangeTrue">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import fileDownload from 'js-file-download'
import {
  checkLedger,
  checkLedgerExport,
  querySelfDisplaycol,
  updateSelfDisplaycol
} from '@/api/detection'
export default {
  data() {
    return {
      listName: 'jCe',
      id: '',
      offset: '', //当前起始位置（page-1）*limit
      page: 1, //当前页
      limit: '10', //
      total: '',
      deviceName: '', //搜索的设备名称
      dialogVisible: false,
      downloadLoading: false,
      tableData: [],
      showColumn: [],
      column: [
        {
          show: false,
          label: '检测日期',
          prop: 'jcsj'
        },
        {
          prop: 'deviceCheckcode',
          show: false,
          label: '报告编号'
        },
        {
          prop: 'projectName',
          show: false,
          label: '工程名称'
        },
        {
          prop: 'unitUse',
          show: false,
          label: '使用单位'
        },
        {
          prop: 'unitInstall',
          show: false,
          label: '安装单位'
        },
        {
          prop: 'projectAddr',
          show: false,
          label: '地区'
        },
        {
          prop: 'unitProduction',
          show: false,
          label: '生产单位'
        },
        {
          prop: 'deviceName',
          show: false,
          label: '设备名称'
        },
        {
          prop: 'deviceModel',
          show: false,
          label: '设备型号'
        },
        {
          prop: 'factoryOutdate',
          show: false,
          label: '出厂日期'
        },
        {
          prop: 'applyTpye',
          show: false,
          label: '检验类型'
        },
        {
          prop: 'jcjl',
          show: false,
          label: '检验结论'
        },
        {
          prop: 'checkUser',
          show: false,
          label: '检验人'
        },
        {
          prop: 'reviewUser',
          show: false,
          label: '核验人'
        },
        {
          prop: 'bfhxsm',
          show: false,
          label: '问题/隐患'
        },
        {
          prop: 'bzxmbhgs',
          show: false,
          label: '保证项不合格'
        },
        {
          prop: 'ybxmbhgs',
          show: false,
          label: '一般项不合格'
        },
        {
          prop: 'payType',
          show: false,
          label: '付款方式'
        },
        {
          prop: 'actualpayment',
          show: false,
          label: '费用'
        },
        {
          prop: 'paymentFlag',
          show: false,
          label: '是否付款'
        },
        {
          prop: 'paymentTime',
          show: false,
          label: '收款日期'
        },
        {
          prop: 'type',
          show: false,
          label: '发票类型'
        },
        {
          prop: 'invoiceTitle',
          show: false,
          label: '抬头'
        },
        {
          prop: 'no',
          show: false,
          label: '开票号码'
        }
      ]
    }
  },
  computed: {
    columnList: function () {
      return this.column.filter((item) => {
        return item.show
      })
    }
  },
  methods: {
    // 关闭显示列选项 改变选项
    tochangeTrue() {
      let arr = this.column.filter((item) => {
        return item.show == true
      })
      this.showColumn = []
      arr.forEach((element) => {
        this.showColumn.push(element.prop)
      })
      var data = {
        id: this.id,
        listName: this.listName,
        displayCol: this.showColumn.toString()
      }
      updateSelfDisplaycol(data).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.dialogVisible = false
        }
      })
    },
    show() {
      this.showColumn.map((item) => {
        let index = this.column.find((i) => {
          return item == i.prop
        })
        index.show = true
      })
    },
    // handleClick(row) {
    //   console.log('1324567u8io')
    //   console.log(row)
    // },
    handleSizeChange(val) {
      this.limit = val
      // console.log(this.limit, this.page)
      this.checkLedger()
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.page = val
      // console.log(this.limit, this.page)
      this.checkLedger()
      // console.log(`当前页: ${val}`)
    },
    // 查询台账
    checkLedger() {
      var data = {
        deviceName: this.deviceName, //设备名称
        offset: (this.page - 1) * this.limit,
        limit: this.limit
      }
      checkLedger(data).then((res) => {
        console.log(res.data)
        this.tableData = res.data.total
        this.total = res.data.rows
      })
    },
    //查询需要展示的列
    querySelfDisplaycol() {
      var data = {
        listName: this.listName
      }
      querySelfDisplaycol(data).then((res) => {
        // console.log(res.data)
        this.id = res.data.id
        this.showColumn = res.data.displayCols
        // console.log(this.showColumn)
        this.show()
      })
    },
    // 点击搜索
    search() {
      console.log(this.deviceName)
      this.page = 1
      this.checkLedger()
    },
    download() {
      this.downloadLoading = true
      console.log(this.deviceName)
      var data = {
        deviceName: this.deviceName
      }
      checkLedgerExport(data).then((res) => {
        fileDownload(res, '检测业务台账.xlsx')
      })
      this.downloadLoading = false
    }
  },
  created() {
    // this.checkLedger()
    this.querySelfDisplaycol()
  },
  mounted() {
    this.checkLedger()
  }
}
</script>

<style lang="scss" scoped>
el-col {
}
a {
  color: cornflowerblue;
  text-decoration: none;
}
/* 控制淡入淡出效果 */
// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.3s;
// }
// .fade-enter,
// .fade-leave-to {
//   opacity: 0;
// }
</style>
